import { render } from "./ProjectsComponent.vue?vue&type=template&id=32a27cb3&ts=true"
import script from "./ProjectsComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__